import { useState } from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import { useUser } from "../../context/UserAuthContext";
import { track } from "../../lib/analytics";
import Seo from "../../components/Seo";
import { toast } from "sonner";

const inp = "w-full px-4 py-3 text-sm rounded-sm border border-brand-gold-light/50 bg-white outline-none focus:border-brand-gold";
const TYPES = [["parent", "Ebeveyn"], ["teacher", "Öğretmen"], ["leader", "Lider / Yönetici"], ["learner", "Öğrenen / Öğrenci"], ["institution", "Kurum"], ["other", "Diğer"]];

export default function Register() {
  const { register } = useUser();
  const nav = useNavigate();
  const [sp] = useSearchParams();
  const next = sp.get("next") || "/hesabim";
  const [f, setF] = useState({ first_name: "", last_name: "", email: "", password: "", phone: "", city: "", user_type: "parent", kvkk_consent: false, marketing_consent: false });
  const [loading, setLoading] = useState(false); const [err, setErr] = useState("");
  const set = (k, v) => setF((s) => ({ ...s, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (!f.kvkk_consent) { toast.error("KVKK onayı gereklidir."); return; }
    setLoading(true); setErr(""); track("signup_started", {});
    const res = await register(f); setLoading(false);
    if (res.ok) { track("signup_completed", {}); toast.success("Hesabın oluşturuldu."); nav(next); }
    else setErr(res.error);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-cream px-6 py-28">
      <Seo title="Kayıt Ol" />
      <div className="w-full max-w-lg bg-brand-offwhite border border-brand-gold-light/40 rounded-sm p-10">
        <Link to="/" className="block text-center font-serif text-2xl font-semibold text-brand-green mb-4">BİLGECE<span className="text-brand-gold align-super text-sm">™</span></Link>
        <h1 className="font-serif text-3xl text-brand-green text-center">Kayıt Ol</h1>
        <p className="text-brand-text/60 text-sm text-center mt-1 mb-6">Bilgece ekosistemine katıl</p>
        <form onSubmit={submit} data-testid="register-form" className="space-y-4">
          <div className="grid sm:grid-cols-2 gap-4">
            <input required placeholder="Ad" value={f.first_name} onChange={(e) => set("first_name", e.target.value)} className={inp} data-testid="reg-first" />
            <input required placeholder="Soyad" value={f.last_name} onChange={(e) => set("last_name", e.target.value)} className={inp} data-testid="reg-last" />
          </div>
          <input required type="email" placeholder="E-posta" value={f.email} onChange={(e) => set("email", e.target.value)} className={inp} data-testid="reg-email" />
          <input required type="password" placeholder="Şifre (en az 6 karakter)" value={f.password} onChange={(e) => set("password", e.target.value)} className={inp} data-testid="reg-password" />
          <div className="grid sm:grid-cols-2 gap-4">
            <input placeholder="Telefon" value={f.phone} onChange={(e) => set("phone", e.target.value)} className={inp} />
            <input placeholder="Şehir" value={f.city} onChange={(e) => set("city", e.target.value)} className={inp} />
          </div>
          <select value={f.user_type} onChange={(e) => set("user_type", e.target.value)} className={inp} data-testid="reg-type">
            {TYPES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
          </select>
          <label className="flex items-start gap-2 text-xs text-brand-text/70"><input type="checkbox" checked={f.kvkk_consent} onChange={(e) => set("kvkk_consent", e.target.checked)} className="mt-0.5 accent-brand-gold" data-testid="reg-kvkk" /><span>KVKK / gizlilik metnini okudum ve onaylıyorum.</span></label>
          <label className="flex items-start gap-2 text-xs text-brand-text/70"><input type="checkbox" checked={f.marketing_consent} onChange={(e) => set("marketing_consent", e.target.checked)} className="mt-0.5 accent-brand-gold" /><span>Bilgece Mektup ve kampanyalardan haberdar olmak istiyorum.</span></label>
          {err && <p className="text-red-700 text-sm" data-testid="register-error">{err}</p>}
          <button disabled={loading} data-testid="register-submit" className="w-full bg-brand-gold text-brand-offwhite hover:bg-brand-green transition-colors py-3 rounded-sm font-semibold disabled:opacity-60">{loading ? "Oluşturuluyor..." : "Hesap Oluştur"}</button>
        </form>
        <p className="text-center mt-5 text-sm text-brand-text/60">Zaten hesabın var mı? <Link to="/giris" className="text-brand-gold font-medium">Giriş Yap</Link></p>
      </div>
    </div>
  );
}
